import React, { useState, createContext, useEffect, useContext } from 'react'

// api
import { getPublicAPI } from '../api'

// contexts
import { ToastContext } from './Toast'

export const ShoppingCartContext = createContext()

export const ShoppingCartProvider = props => {
   const { setToasts } = useContext(ToastContext)

   const [shopping, setShopping] = useState(true)
   const [drawerOpen, setDrawerOpen] = useState()
   const [productsCount, setProductsCount] = useState(0)
   const [searchC, setSearchC] = useState('')
   const [selectedFittingsC, setSelectedFittingsC] = useState([])
   const [hoseSizesC, setHoseSizesC] = useState([])
   const [dashSizesC, setDashSizesC] = useState([])
   const [selectedHoseSizesC, setSelectedHoseSizesC] = useState([])
   const [selectedDashSizesC, setSelectedDashSizesC] = useState([])
   const [price, setPrice] = useState([])
   const [newFits, setNewFits] = useState(false)
   const [uploadedNewFits, setUploadedNewFits] = useState(false)
   const [viewC, setViewC] = useState(parseInt(localStorage.view_c || 1) === 1)
   const [fittingsC, setFittingsC] = useState([])

   // const [hoses, setHoses] = useState(0)
   const [selectedHosesC, setSelectedHosesC] = useState([])
   const [selectedProductsC, setSelectedProductsC] = useState([])
   const [pressuresC, setPressuresC] = useState([])
   const [sizesC, setSizesC] = useState([])
   const [selectedPressuresC, setSelectedPressuresC] = useState([])
   const [selectedSizesC, setSelectedSizesC] = useState([])
   const [newHos, setNewHos] = useState(false)
   const [uploadedNewHos, setUploadedNewHos] = useState(false)
   const [hosesC, setHosesC] = useState([])
   const [allProducts, setAllProducts] = useState([])
   const [productRoute, setProductRoute] = useState('')
   const [searchCustomer, setSearchCustomer] = useState('')
   const [searchAdmin, setSearchAdmin] = useState('')
   const [openFittings, setOpenFittings] = React.useState(true)
   const [openHoses, setOpenHoses] = React.useState(false)

   useEffect(() => {
      const prepareCart = async () => {
         let cartsData = {
            user: localStorage.auth_token ? localStorage.user_email : localStorage.ip_address
         }

         let cartProducts = await getPublicAPI('/get-cart-products', cartsData)
         if (cartProducts?.success) setProductsCount(cartProducts.data.length)
         else setToasts({ type: 'error', messages: cartProducts?.errors })
      }

      prepareCart()
   }, [shopping, setToasts])

   const handleSizesC = (type, size) => {
      if (type === 'hose') {
         if (selectedHoseSizesC.includes(size)) {
            let newHoses = selectedHoseSizesC.filter(sizes => sizes !== size)
            setSelectedHoseSizesC(newHoses)
         } else setSelectedHoseSizesC([...selectedHoseSizesC, size])
      } else {
         if (selectedDashSizesC.includes(size)) {
            let newDashes = selectedDashSizesC.filter(sizes => sizes !== size)
            setSelectedDashSizesC(newDashes)
         } else setSelectedDashSizesC([...selectedDashSizesC, size])
      }
   }

   const handleHosesC = (type, size) => {
      if (type === 'pressure') {
         if (selectedPressuresC.includes(size)) {
            let newPressures = selectedPressuresC.filter(sizes => sizes !== size)
            setSelectedPressuresC(newPressures)
         } else setSelectedPressuresC([...selectedPressuresC, size])
      } else {
         if (selectedSizesC.includes(size)) {
            let newSizes = selectedSizesC.filter(sizes => sizes !== size)
            setSelectedSizesC(newSizes)
         } else setSelectedSizesC([...selectedSizesC, size])
      }
   }

   return (
      <ShoppingCartContext.Provider
         value={{
            shopping,
            setShopping,
            productsCount,
            searchC,
            setSearchC,
            selectedFittingsC,
            setSelectedFittingsC,
            hoseSizesC,
            setHoseSizesC,
            dashSizesC,
            setDashSizesC,
            selectedHoseSizesC,
            setSelectedHoseSizesC,
            selectedDashSizesC,
            setSelectedDashSizesC,
            setPrice,
            price,
            handleSizesC,
            newFits,
            setNewFits,
            uploadedNewFits,
            setUploadedNewFits,
            viewC,
            setViewC,
            fittingsC,
            setFittingsC,
            // hoses,
            selectedHosesC,
            setSelectedHosesC,
            pressuresC,
            setPressuresC,
            sizesC,
            setSizesC,
            selectedPressuresC,
            setSelectedPressuresC,
            selectedSizesC,
            setSelectedSizesC,
            handleHosesC,
            newHos,
            setNewHos,
            uploadedNewHos,
            setUploadedNewHos,
            hosesC,
            setHosesC,
            drawerOpen,
            setDrawerOpen,
            selectedProductsC,
            setSelectedProductsC,
            setAllProducts,
            allProducts,
            productRoute,
            setProductRoute,
            searchCustomer,
            setSearchCustomer,
            searchAdmin,
            setSearchAdmin,
            openFittings,
            setOpenFittings,
            openHoses,
            setOpenHoses
         }}
      >
         {props.children}
      </ShoppingCartContext.Provider>
   )
}
